import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { Input, InputPhone } from 'components';
import { useLang } from '../PlayerRegistration';
import './style.scss';

export const Step2 = () => {
  const { t } = useLang();

  return (
    <Layout className="player-registration__step-2">
      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_2')}</Typography.Title>
        </Col>
        <Col span={24}>
          <Typography.Text>{t('description_step_2')}</Typography.Text>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col flex="1">
          <Input
            name="email"
            label={t('label_email')}
            rules={[
              { required: true, message: t('error_email') },
              { type: 'email', message: t('error_email_format') },
            ]}
            formItemProps={{
              normalize: (value) => value.replace(/[^a-zA-Z0-9@._%+-]/g, ''),
            }}
          />
        </Col>
        <Col flex="168px">
          <InputPhone
            name="phone"
            label={t('label_phone')}
            rules={[
              { required: true, message: t('error_phone') },
              {
                pattern: /^\D*(\d\D*){10}$/,
                message: t('error_phone_format'),
              },
            ]}
          />
        </Col>
      </Row>
    </Layout>
  );
};
